import ProfileHero, {
  INITIAL_SCROLL_TOP,
  INITIAL_HEIGHT,
  FULL_HEIGHT,
  getHeightTillSubnavbar,
  ProfileHeroHeightNames,
} from './ProfileHero';
import ProfileHeroContainer from './ProfileHero.container';

export default ProfileHeroContainer(ProfileHero);
export {
  INITIAL_SCROLL_TOP,
  INITIAL_HEIGHT,
  FULL_HEIGHT,
  getHeightTillSubnavbar,
  ProfileHeroHeightNames,
};
